import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StopSelect from '../../shared/components/StopSelect';
import isEmpty from 'lodash/isEmpty';

export default class StopSelectContainer extends Component {
    static propTypes = {
        id: PropTypes.string,
        routeId: PropTypes.string,
        type: PropTypes.string,
        purpose: PropTypes.string,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
        firstInput: PropTypes.object,
        secondInput: PropTypes.object,
        focused: PropTypes.bool
    };

    static defaultProps = {
        id: null,
        type: 'all',
        routeId: null,
        purpose: null,
        firstInput: null,
        secondInput: null,
        focused: false,
        onBlur: () => {}
    };

    constructor(props) {
        super(props);

        this.state = {
            expand: false,
            focusedInput: props.focused ? 'first' : null
        };
    }

    /*componentWillReceiveProps(nextProps) {
        if (null === nextProps.firstInput) {
            this.setState({
                expand: false
            });
        }
    }*/

    handleFirstInputChange(value) {
        const expandsAndFocusSecondInput = !isEmpty(value) && 'stop' !== value.type;

        this.setState({
            expand: expandsAndFocusSecondInput,
            focusedInput: expandsAndFocusSecondInput ? 'second' : null
        });

        this.props.onChange({
            firstInput: value,
            secondInput: null
        });
    }

    handleSecondInputChange(value) {
        this.props.onChange({
            firstInput: this.props.firstInput,
            secondInput: value
        });
    }

    render() {
        const { onBlur, firstInput, secondInput, ...others } = this.props;
        const { expand, focusedInput } = this.state;

        return (
            <StopSelect
                {...others}
                expand={expand}
                firstInput={{
                    value: firstInput,
                    onChange: ::this.handleFirstInputChange,
                    onBlur: onBlur,
                    focused: 'first' == focusedInput
                }}
                secondInput={{
                    value: secondInput,
                    onChange: ::this.handleSecondInputChange,
                    onBlur: onBlur,
                    focused: 'second' == focusedInput
                }}
            />
        );
    }
}
